import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditTLO,
} from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useComparableDeal } from "web/hooks/data"
import React, { Suspense } from "react"

export default class ComparableDealViewOrEditTLOController extends Controller {
  static values = {
    comparableDealId: Number,
    excludedFieldIds: Array,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const ComparableDealTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="sale"
          data={useComparableDeal(this.comparableDealIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ComparableDealTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditTLO
                    excludedFieldIds={this.excludedFieldIdsValue}
                    supportsMissingStageFields
                  />
                </ErrorBoundary>
              </ComparableDealTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
